import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Youtube, X, Link2 } from 'lucide-react';

// TikTok and Bluesky have no lucide equivalents.
export const TikTokIcon = ({ className, style }) => (
  <svg className={className} style={style} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export const BlueSkyIcon = ({ className, style }) => (
  <svg className={className} style={style} viewBox="0 0 568 501" fill="currentColor">
    <path d="M123.121 33.664C188.241 82.553 258.281 181.68 284 234.873c25.719-53.192 95.759-152.32 160.879-201.209C491.866-1.611 568-28.906 568 57.947c0 17.346-9.945 145.713-15.778 166.555-20.275 72.453-94.155 90.933-159.875 79.748C507.222 323.8 536.444 388.56 473.333 453.32c-119.86 122.992-172.272-30.859-185.702-70.281-2.462-7.227-3.614-10.608-3.631-7.74-.017-2.868-1.169.513-3.631 7.74-13.43 39.422-65.842 193.273-185.702 70.281-63.111-64.76-33.889-129.52 80.986-149.065-65.72 11.185-139.6-7.295-159.875-79.748C9.945 203.659 0 75.291 0 57.947 0-28.906 76.134-1.611 123.121 33.664Z"/>
  </svg>
);

export const socialMediaIcons = {
  facebook: { icon: Facebook, color: '#1877F2' },
  twitter: { icon: X, color: '#000000' },
  linkedin: { icon: Linkedin, color: '#0A66C2' },
  instagram: { icon: Instagram, color: '#E4405F' },
  youtube: { icon: Youtube, color: '#FF0000' },
  tiktok: { icon: TikTokIcon, color: '#000000' },
  bluesky: { icon: BlueSkyIcon, color: '#0085FF' },
  custom: { icon: Link2, color: '#334155' }
};
